import styled, { css } from 'styled-components'

const StyledEditableTextDivContainer = styled.div`
  display: flex;
  ${props =>
    props.hasMarginTop &&
    css`
      margin-top: 30px;
    `};
`
export default StyledEditableTextDivContainer
